<template>
    <div class="client-photo-cropper">
        <vue-cropper class="client-photo-content"
                ref="cropper"
                :src="src"
                :aspectRatio="1"
                 :autoCropArea="1"
        />
        <div class="client-photo-actions">
            <v-btn @click.prevent="crop" color="success" small fab class="mx-4">
                <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn @click.prevent="$emit('cancel')" color="error" small fab class="mx-4">
                <v-icon>mdi-cancel</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
        name      : "EditPhoto",
        props     : {
            src: {
                required: true
            }
        },
        components: {VueCropper},
        methods   : {
            crop() {
                this.$emit('input', this.$refs.cropper.getCroppedCanvas().toDataURL());
                this.$emit('cancel');
            }
        }
    }
</script>

<style scoped>

</style>
